<app-component-subnav></app-component-subnav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Baugruppen</h2>
  <clr-datagrid *ngIf="components.length > 0" [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'material'">Material</clr-dg-column>
    <clr-dg-column [clrDgField]="'description'">Kurzbeschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'number_of_pieces_in_stock'">Lagerbestand (Warehouse)</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Component!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let assembly of components" [routerLink]="['/component/details', assembly.technical_drawing]">
      <clr-dg-cell>{{ assembly.technical_drawing }}</clr-dg-cell>
      <clr-dg-cell><b>{{ assembly.name }}</b></clr-dg-cell>
      <clr-dg-cell>{{ assembly.material }}</clr-dg-cell>
      <clr-dg-cell>{{ assembly.description }}</clr-dg-cell>
      <clr-dg-cell>{{ assembly.number_of_pieces_in_stock }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Komponenten pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{ components.length }} Komponente(n)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
